import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=5ac8b267&scoped=true&"
import script from "./FileTable.vue?vue&type=script&lang=js&"
export * from "./FileTable.vue?vue&type=script&lang=js&"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=5ac8b267&prod&lang=scss&scoped=true&"
import style1 from "./FileTable.vue?vue&type=style&index=1&id=5ac8b267&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8b267",
  null
  
)

export default component.exports